import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { NzModalRef } from 'ng-zorro-antd/modal';
import { TranslateService } from '@ngx-translate/core';
import {
  CASHIER_SET_UP,
  CLOSE_ICON,
  CASH_DRAWER_WARNING,
} from 'src/defaultImages.js';
import { SetupBillingCounterModalType } from 'src/app/common/enums/billing-counter.enum';

@Component({
  selector: 'app-billing-counter-setup',
  templateUrl: './billing-counter-setup.component.html',
  styleUrls: ['./billing-counter-setup.component.css'],
})
export class BillingCounterSetupComponent implements OnInit, OnDestroy {
  @Input() modalData: any = {};
  images = {
    CASHIER_SET_UP,
    CLOSE_ICON,
    CASH_DRAWER_WARNING,
  };
  enum = SetupBillingCounterModalType;
  subscription: Subscription = new Subscription();
  translationText = {};
  showWarningPage: boolean = false;

  constructor(
    private _modalRef: NzModalRef,
    private _router: Router,
    private _translateService: TranslateService
  ) {}

  ngOnInit(): void {
    this.showWarningPage = this.modalData?.type === this.enum.WARNING;
    this.setTranslations();
  }

  ngOnDestroy(): void {
    this.subscription?.unsubscribe();
  }

  handleBtnClick(): void {
    if (this.showWarningPage) {
      this._modalRef.close({
        status: 0,
        message: 'got-it',
        data: null,
      });
    } else {
      this._router.navigate(['/section-counters'], {
        queryParams: { tab: 'bill_receipt_settings' },
      });
      this._modalRef.close({
        status: 1,
        message: 'navigate-to-settings',
        data: null,
      });
    }
  }

  closeModal(): void {
    this._modalRef.close({ status: 0, message: 'modal-closed', data: null });
  }

  private setTranslations(): void {
    this.subscription.add(
      this._translateService
        .get('COUNTER_SET_UP_MODAL')
        .subscribe((translations) => {
          this.translationText = translations || {};
        })
    );
  }
}
